var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"padding-top":"100px"}},[_c('h1',{staticClass:"h1"},[_vm._v("打开你好陈真小程序")]),_c('div',{staticClass:"btn",on:{"click":_vm.toWX}},[_vm._v("你好，陈真")])])])}
var staticRenderFns = []

export { render, staticRenderFns }